<template>
  <div class="office-hr-card">
    <!-- 办公室 -->
    <div class="section">
      <div v-if="officeInfo.length > 0" class="section-title">
        <div class="title-bar"></div>
        <h3>办公室</h3>
      </div>
      <div class="section-content flex-layout">
        <div v-for="(item, index) in officeInfo" :key="index" class="info-item">
          <div class="icon-container">
            <div class="icon" :class="item.type"></div>
          </div>
          <div class="info-text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <div v-if="hrInfo.length > 0" class="divider"></div>

    <!-- 人力资源 -->
    <div class="section">
      <div v-if="hrInfo.length > 0" class="section-title">
        <div class="title-bar"></div>
        <h3>人力资源</h3>
      </div>
      <div class="section-content flex-layout">
        <div v-for="(item, index) in hrInfo" :key="index" class="info-item">
          <div class="icon-container">
            <div class="icon" :class="item.type"></div>
          </div>
          <div class="info-text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  officeInfo: {
    type: Array,
    required: true
  },
  hrInfo: {
    type: Array,
    required: true
  }
})
</script>

<style scoped>
.office-hr-card {
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: box-shadow 0.3s ease;
  margin-bottom: 40px;
}

.section {
  margin-bottom: 20px;
}

.section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.title-bar {
  width: 4px;
  height: 16px;
  background-color: #0055A2;
  margin-right: 10px;
}

.section-title h3 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

/* 办公室和人力资源布局 */
.flex-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.flex-layout .info-item {
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  min-width: 200px;
}

.info-item {
  display: flex;
  align-items: flex-start;
}

.icon-container {
  margin-right: 16px;
  display: flex;
  align-items: center;
}

.icon {
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.icon.phone {
  background-image: url("@/assets/phone.png");
  width: 13px;
  height: 13px;
}

.icon.fax {
  background-image: url("@/assets/fax.png");
  width: 13px;
  height: 13px;
}

.icon.email {
  background-image: url("@/assets/email.png");
  width: 13px;
  height: 13px;
}

.icon.wechat {
  background-image: url("@/assets/wechat.png");
  width: 13px;
  height: 13px;
}

.info-text {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

/* 分隔线 */
.divider {
  height: 1px;
  background-color: #eee;
  margin: 20px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .office-hr-card {
    padding: 15px;
  }

  .flex-layout .info-item {
    min-width: 150px;
  }

  .divider {
    margin: 15px 0;
  }
}

@media (max-width: 480px) {
  .office-hr-card {
    padding: 12px;
  }

  .flex-layout {
    flex-direction: column;
    gap: 12px;
  }

  .flex-layout .info-item {
    min-width: 100%;
  }

  .section-title h3 {
    font-size: 15px;
  }

  .info-text {
    font-size: 13px;
  }

  .divider {
    margin: 12px 0;
  }
}
</style>